module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/i3Bioh/tc-custom/9781642796124.jpg?1703851145279",
      "alt": "This image is the cover for the book Cricket Catches the Travel Bug, The Travel Bug Tales"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cricket Catches the Travel Bug, The Travel Bug Tales\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Meet Cricket—and join her on a traveling adventure—in this delightful storybook from the creator of the Mom with a Map website.")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Cricket Catches the Travel Bug")]), _vm._v(" gives a first introduction to the silly little travel bug, Cricket. Young readers join her as she learns all about travel, including her first flight aboard an airplane. She’s amazed at how high these machines can fly—much higher than her own wings! Kids explore a big city with Cricket and her family and love learning all about travel through a bug’s eyes!"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" As "), _c('i', [_vm._v("Cricket Catches the Travel Bug")]), _vm._v(" quickly becomes a family favorite, parents appreciate Cricket’s cute interpretation and imagination, while children fall in love with Cricket … and with travel. Look out, the travel bug is highly contagious!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah Bowlin, Jami Owen\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Morgan James Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0